import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { getSSOToken } from '../services/auth'
import { isMockApi } from '../mock/isMockApi'

const AI_ASSISTANT_URL = process.env.REACT_APP_AI_ASSISTANT_URL

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1150,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    flex: 1,
  },
}

class AIAssistantModal extends React.PureComponent {
  buildIframeSrc = () => {
    if (!AI_ASSISTANT_URL) return null
    const ssoToken = isMockApi() ? 'local-dev' : getSSOToken()
    if (!ssoToken) return null

    try {
      const url = new URL(AI_ASSISTANT_URL)
      url.searchParams.set('token', ssoToken)
      if (this.props.continueOnboarding) url.searchParams.set('onboarding', '1')
      return url.toString()
    } catch (error) {
      const joiner = String(AI_ASSISTANT_URL).includes('?') ? '&' : '?'
      const onboarding = this.props.continueOnboarding ? '&onboarding=1' : ''
      return `${AI_ASSISTANT_URL}${joiner}token=${encodeURIComponent(ssoToken)}${onboarding}`
    }
  }

  render() {
    const { classes, open } = this.props
    if (!open) return null
    const src = this.buildIframeSrc()
    if (!src) return (
      <div className={classes.overlay} style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#666', fontSize: 14, textAlign: 'center', padding: '0 24px' }}>
          Não foi possível iniciar o assistente. Feche e tente novamente.
        </p>
      </div>
    )
    return (
      <div className={classes.overlay}>
        <iframe
          data-informed-ai="true"
          src={src}
          className={classes.iframe}
          title="Informed IA"
        />
      </div>
    )
  }
}

export default withStyles(styles)(AIAssistantModal)
